import {
  DEFAULT_ROUTER_LOCALE,
  SUPPORTED_ROUTER_LOCALE,
} from "@constants/global.constants";
import { RoutesLocaleType } from "@typings/global.types";

const parsePathname = (pathname: string): RoutesLocaleType | undefined => {
  const chunks: string[] = pathname.split("/", 2);
  if (chunks.length < 2 || SUPPORTED_ROUTER_LOCALE.indexOf(chunks[1]) === -1) {
    return undefined;
  }
  return chunks[1] as RoutesLocaleType;
};

export const getCurrentRouteLocale = (): RoutesLocaleType => {
  const urlObject = new URL(window.location.href);
  return parsePathname(urlObject.pathname) || DEFAULT_ROUTER_LOCALE;
};
